import React from 'react';
import PropTypes from 'prop-types';

const ThreeColumnTiles = ({ columnData }) => {
  return (
    <div className="training-dates-main">
      <div className="row">
        {columnData.map((column) => (
          <div className="col-md-4">
            <div className="single-training-date">
              <h3>{column.title}</h3>
              <p>{column.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

ThreeColumnTiles.propTypes = {
  columnData: PropTypes.array,
};

export default ThreeColumnTiles;
